import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import Breadcrumb from '../components/Breadcrumb';
import UsersListLayer from '../components/UsersListLayer';
import { useSearchParams } from 'react-router-dom';
import { useFetch } from '../hook/useFecth';

const UsersListPage = () => {
    const [searchParams] = useSearchParams();
    const { data } = useFetch(`/usuario`, { params: { ...Object.fromEntries([...searchParams]) } });
    return (
        <>
            {/* Breadcrumb */}
            <Breadcrumb title="Usuários" icon="solar:users-group-rounded-outline" />

            {/* UsersListLayer */}
            <UsersListLayer data={data} />
        </>
    );
};

export default UsersListPage;
